<template>
  <div>
    <b-row :key="refreshImport">
      <b-col :sm="(field.type === 'file') ? '12' : '6'" class="form-group"
        v-for="(field, indexField) in currentStep.fields" :key="indexField"
        v-if="showWithDependency(field, currentStep.fields)">
        <!-- <form-write-group-label-input
          v-if="['date', 'number', 'text'].includes(field.type)"
          :inputLabel="$t('suppliers.kyc_form.' + step.step_label + '.' + field.label)"
          :inputType="field.type"
          :typingDone="refreshVue()"
          :specificErrorIndicator="document.Serialize[value.name].Valid === '0'"
          :warningIndicator="controlsConfig === '1' ? showWarningIndicator(value.name, document.Serialize) : false"
          :specificMessage="controlsConfig === '1' ? getAssociatedMessage(document.Serialize[value.name].Description) : ''"
          v-model="field.value">
        </form-write-group-label-input> -->
        <form-write-group-label-input
          v-if="field.type === 'date'"
          :inputLabel="$t('suppliers.kyc_form.' + currentStep.step_label + '.' + field.label)"
          inputType="date"
          v-model="field.value">
        </form-write-group-label-input>
        <div v-else-if="field.type === 'text'">
          <label>
            {{ $t('suppliers.kyc_form.' + currentStep.step_label + '.' + field.label) }}
            <span v-if="field.required && field.required === 'true'" class="color-red">* </span>
          </label>
          <input class="form-control inputAccordionForm"
            type="text"
            @change="refreshImport = !refreshImport"
            v-model="field.value"
            :class="(hasError(field)) ? 'errorBorder' : ''">
          </input>
          <div v-if="!demoErrorSilent.includes(field.errorDesc)" style="color:red;">
            {{ field.errorDesc }}
          </div>
        </div>
        <div v-else-if="field.type === 'checkbox'">
          <label>
            {{ $t('suppliers.kyc_form.' + currentStep.step_label + '.' + field.label) }}
          </label>
          <b-form-checkbox v-model="field.value"
            value="true" unchecked-value="false"
            @change="refreshImport = !refreshImport">
          </b-form-checkbox>
        </div>
        <div v-else-if="field.type === 'radio'">
          <label>
            {{ $t('suppliers.kyc_form.' + currentStep.step_label + '.' + field.label + '._label') }}
            <span v-if="field.required && field.required === 'true'" class="color-red">* </span>
          </label>
          <b-form-radio v-for="radioValue in field.possible_values" :key="radioValue"
            v-model="field.value" :value="radioValue" :name="field.label + '-radio'">
            {{ $t('suppliers.kyc_form.' + currentStep.step_label + '.' + field.label + '.' + radioValue) }}
          </b-form-radio>
        </div>
        <form-write-group-label-input
          v-else-if="field.type === 'list'"
          :isMandatory="field.required && field.required === 'true'"
          :inputLabel="$t('suppliers.kyc_form.' + currentStep.step_label + '.' + field.label + '._label')"
          :inputType="field.type">
          <select class="form-control" readonly v-model="field.value"
            @change="checkInvalidValue(field)"
            :class="(hasError(field)) ? 'errorBorder' : ''">
            <option value=""></option>
            <option v-for="optionValue in field.possible_values" :value="optionValue">
              {{ $t('suppliers.kyc_form.' + currentStep.step_label + '.' + field.label + '.' + optionValue) }}
            </option>
          </select>
          <div v-if="!demoErrorSilent.includes(field.errorDesc)" style="color:red;">
            {{ field.errorDesc }}
          </div>
        </form-write-group-label-input>
        <div v-else-if="field.type === 'file'" class="row">
          <b-col sm="6">
            <label>
              {{ $t('suppliers.kyc_form.' + currentStep.step_label + '.' + field.label) }}
              <span v-if="field.required && field.required === 'true'" class="color-red">* </span>
            </label>
            <div v-if="field.value === 'true'">
              <b-row v-if="step.documentData">
                <b-col sm="4" class="form-group">
                  <div class="d-flex justify-content-between">
                    <label id="application-file-input">
                      {{ $t('attachments.' + step.documentType) }}
                    </label>
                    <div class="d-flex">
                      <i class="icon fa fa-download mx-1" @click="download(step)"></i>
                    </div>
                  </div>
                </b-col>
                <b-col sm="4" class="form-group">
                  <f7-button round class="generalBottomButton"
                    @click="clearDocument(field)">
                    {{ $t('common.rm_label') }}
                  </f7-button>
                </b-col>
              </b-row>
            </div>
            <b-row class="justify-content-start">
              <b-col class="form-group">
                <f7-button round class="generalBottomButton"
                  @click="openFileSelectionWindow($event, 'fileButton' + field.label)">
                  {{ $t('attachments.import_doc') }}
                </f7-button>
                <input class="item-input hiddenElementAllSize local-file-input"
                  :ref="'fileButton' + field.label" type="file"
                  @change="executeOCR($event, field, currentStep)">
                </input>
              </b-col>
            </b-row>
            <b-row class="justify-content-start">
              <b-col v-if="field.doc_type === 'KBIS' || field.doc_type === 'STATUS'" class="form-group">
                <f7-button round class="generalBottomButton"
                  @click="callInstitutionalSource($event, field, currentStep)">
                  {{ $t('suppliers.ask_institut') }}
                </f7-button>
              </b-col>
            </b-row>
          </b-col>
          <b-col sm="6">
            <f7-button round class="generalBottomButton"
              style="margin-top:26px;"
              v-if="field.doc_type === 'BILAN'"
              @click="callInstitutionalSourceInfo($event, field, currentStep)">
              {{ $t('suppliers.ask_institut_info') }}
            </f7-button>
          </b-col>
        </div>
      </b-col>
    </b-row>
    <b-row class="justify-content-start"
      v-if="showActionButtons()">
      <template v-if="showActionButtonValidate()">
        <b-col md="3" offset-md="6" class="form-group">
          <f7-button class="button-action milkyBlockBlack"
            @click="decideStep(102)">
            {{ $t('common.sve') }}
          </f7-button>
        </b-col>
        <b-col md="3" class="form-group">
          <f7-button class="button-action milkyBlockBlack"
            :disabled="checkKYCError()"
            @click="decideStep(103)">
            {{ $t('creation_forms.vldt') }}
          </f7-button>
        </b-col>
      </template>
      <template v-if="showActionButtonValidateBackOffice()">
        <!-- <b-col md="3" offset-md="3" class="form-group">
          <f7-button class="button-action milkyBlockBlack"
            v-if="step.documentData"
            @click="executeOCRFile(step.documentType, step.documentData, currentStep)">
            <f7-icon fa="cog"></f7-icon>
            {{ $t('common.cntrl') }}
          </f7-button>
        </b-col> -->
        <b-col md="3" offset-md="6" class="form-group">
          <f7-button class="button-action milkyBlockBlack"
            @click="refuseStep()">
            <f7-icon fa="times"></f7-icon>
            {{ $t('common.refus') }}
          </f7-button>
        </b-col>
        <b-col md="3" class="form-group">
          <f7-button class="button-action milkyBlockBlack"
            @click="decideStep(104)">
            <f7-icon fa="check"></f7-icon>
            {{ $t('creation_forms.vldt') }}
          </f7-button>
        </b-col>
      </template>
    </b-row>
  </div>
</template>

<script>
import b64toBlob from 'b64-to-blob'

import legalStatusList from './data/legalstatus.json'

import formWriteGroupLabelInput from '@/components/common/formWriteGroupLabelInput.vue'

import {errorMessageAlert} from '@/helpers/alert'

export default {
  name: 'SupplierKYCFormStep',
  components: {
    'form-write-group-label-input': formWriteGroupLabelInput
  },
  props: {
    seller: {
      type: Object,
      default: null
    },
    step: {
      type: Object,
      default: null
    }
  },
  data () {
    return {
      demoErrorSilent: [
        'CompanyName is not consistency',
        'Data different from API',
        'Data format invalid',
        'Date inconsistent with delivery date',
        'Unknown BIC'
      ],
      docTypesOCR: ['CERTIFICATE_INCORPORATION', 'IDCARD', 'KBIS', 'MEMORANDUM', 'RIB'],
      institutionalSourceableDocuments: ['Kbis', 'Status'],
      refreshImport: false
    }
  },
  created () {
    this.currentStep = this.step
    for (let indexField in this.step.fields) {
      let field = this.step.fields[indexField]
      if (field.sellerInfo && field.value === '') {
        if (field.label === 'LegalForm' && field.value === '') {
          legalStatusList[this.seller['Country']].map(legalStatus => {
            if (this.seller['LegalForm'] === legalStatus.code) {
              field.value = legalStatus.label
            }
          })
        } else {
          field.value = this.seller[field.label]
        }
      }
      if (field.label === 'Country' && field.value === '') {
        switch (this.seller['Country']) {
          case 'FR':
            field.value = 'France'
            break
          case 'UK':
            field.value = 'United Kingdom'
            break
          default:
            field.value = 'France'
        }
      }
    }
  },
  methods: {
    callInstitutionalSource (e, field, step) {
      e.stopPropagation()
      let that = this
      this.$f7.showPreloader(this.$i18n.t('loading.asking_instit'))
      let params = {
        Siren: this.seller.Siren,
        DocType: field.doc_type
      }
      this.$engine.services.suppliers.getDocumentFromInstitutionalSource(params)
      .then(response => {
        if (response.status === 200) {
          this.$f7.hidePreloader()
          field.value = 'true'
          step.documentData = response.data.DocumentData
          step.documentType = field.doc_type
          if (field.value === 'true' && field.doc_type === 'KBIS') that.executeOCRFile(field.doc_type, response.data.DocumentData, step)
          this.refreshImport = !this.refreshImport
          // this.fileArray.push({'Name': response.data.DocumentName, 'Content': response.data.DocumentData})
        }
      })
      .catch(error => {
        errorMessageAlert(error, that)
      })
    },
    callInstitutionalSourceInfo (e, field, step) {
      e.stopPropagation()
      let that = this
      this.$f7.showPreloader(this.$i18n.t('loading.asking_instit'))
      let params = {
        Siren: this.seller.Siren,
        DocType: field.doc_type
      }
      this.$engine.services.suppliers.getInfoFromInstitutionalSource(params)
      .then(response => {
        if (response.status === 200) {
          this.$f7.hidePreloader()
          let bilanInfo = {
            BILAN_YEAR: 'Year_1',
            TURNOVER: 'SalesFigures_1'
          }
          for (let indexField in this.step.fields) {
            let field = this.step.fields[indexField]
            if (bilanInfo[field.label] && response.data[bilanInfo[field.label]]) {
              field.value = response.data[bilanInfo[field.label]]
            }
          }
          this.refreshImport = !this.refreshImport
        }
      })
      .catch(error => {
        errorMessageAlert(error, that)
      })
    },
    checkInvalidValue (field) {
      if (field.value === 'AFG' || field.value === 'IRN' || field.value === 'PRK') {
        field.valid = '0'
        field.errorDesc = 'Pays non autorisé'
      } else {
        field.valid = '1'
        field.errorDesc = ''
      }
    },
    checkKYCError () {
      if (this.seller.Country === 'FR') {
        for (let indexField in this.step.fields) {
          let field = this.step.fields[indexField]
          if ((field.valid && field.valid === '0') ||
          (field.required && field.required === 'true' &&
          this.showWithDependency(field, this.step.fields) && field.value === '')) {
            return true
          }
        }
        return false
      }
      return false
    },
    clearDocument (field) {
      this.refreshImport = !this.refreshImport
      field.value = ''
      this.currentStep.documentData = ''
      this.currentStep.documentDate = ''
      this.currentStep.documentType = ''
    },
    decideStep (status) {
      this.step.fields = this.step.fields.map(field => {
        let newField = {}
        let fieldKeys = Object.keys(field)
        fieldKeys.forEach(fieldKey => {
          newField[fieldKey] = field[fieldKey]
        })
        if (field.value instanceof Date) {
          newField.value = field.value.toISOString().split('T')[0]
        }
        return newField
      })
      this.currentStep.status = status
      this.$bus.$emit('decideStep', this.currentStep)
    },
    download (step) {
      let attachmentData = step.documentData
      let attachmentName = this.$t('attachments.' + step.documentType)
      let dataB64 = attachmentData.split(',')[1]
      let contentType = attachmentData.split(';')[0].replace(/^data:/, '')
      let blob = b64toBlob(dataB64, contentType)
      let url = window.URL.createObjectURL(blob)
      let fileLink = document.createElement('a')
      fileLink.href = url
      fileLink.setAttribute('download', attachmentName)
      fileLink.click()
    },
    executeOCR (e, field, step) {
      var files = e.target.files
      if (!files.length) { return }
      if (files[0].size <= 50000000) {
        let that = this
        // let id = field.value.length
        // field.value.push({})
        var reader = new FileReader()
        reader.onload = (e) => {
          field.value = 'true'
          step.documentData = reader.result
          step.documentType = field.doc_type
          // field.value[id].AttachmentData = reader.result
          if (field.value === 'true' && this.docTypesOCR.includes(field.doc_type)) that.executeOCRFile(field.doc_type, reader.result, step)
        }
        // field.value[id].AttachmentName = files[0].name
        this.refreshImport = !this.refreshImport
        return reader.readAsDataURL(files[0])
      } else {
        this.$f7.alert(
          this.$i18n.t('creation_forms.file_size') +
          Math.round(files[0].size / 1000) +
          this.$i18n.t('creation_forms.max_file_size') +
          '500 Kb',
          this.$i18n.t('creation_forms.max_size_title')
        )
        this.refreshImport = !this.refreshImport
      }
    },
    executeOCRFile (filetype, file, step) {
      let that = this

      that.$f7.showPreloader(that.$i18n.t('sent.ocr_loading', {request_type: that.$i18n.t('servicesNames.req_to_py_sing')}))
      // Call API for OCR
      return that.$engine.ocr.ocrRequest(
        that.$engine.user.get().id,
        '',
        file,
        'jpeg',
        'scan',
        filetype
      ).then(response => {
        that.$f7.hidePreloader()
        that.$f7.modal({
          title: that.$i18n.t('sent.ocr_end'),
          text: '<span class="preloader"></span>'
        })
        that.$f7.hidePreloader()
        that.$f7.closeModal()

        // Extract DocumentData from response
        response = response.data.ControlsInformations

        step.fields = step.fields.map(field => {
          let newField = {}
          let fieldKeys = Object.keys(field).filter(elem => elem !== 'valid' && elem !== 'errorDesc')
          fieldKeys.forEach(fieldKey => {
            newField[fieldKey] = field[fieldKey]
          })
          return newField
        })

        if (filetype === 'MEMORANDUM') {
          for (let fieldIndex in step.fields) {
            let field = step.fields[fieldIndex]
            if (field.label === 'COMPANY_HAS_OTHER_INFLUENCIAL_PEOPLE') {
              field.value = 'true'
            }
          }
        }

        for (var key in response) {
          var ExtractedValue = response[key].Value
          if (ExtractedValue) {
            if (ExtractedValue === '$Error' || ExtractedValue === '$NotFound') {
              ExtractedValue = ''
            }
            for (let fieldIndex in step.fields) {
              let fieldToOCR = step.fields[fieldIndex]

              if (key === fieldToOCR.label && (fieldToOCR.value === '' || step.status === 101 || step.status === 102 || step.status === 105 || step.status === 103)) {
                if (this.$engine.user.get().identifier !== 'backoffice@demosoft.com') {
                  fieldToOCR.value = ExtractedValue
                }
                if (ExtractedValue !== '2022-02-07' && ExtractedValue !== '2022-02-09' &&
                  !that.demoErrorSilent.includes(response[key].Description)) {
                  fieldToOCR.valid = response[key].Valid
                  fieldToOCR.errorDesc = response[key].Description
                }
                if (fieldToOCR.compare && ExtractedValue.toUpperCase() !== this.seller[fieldToOCR.compare].toUpperCase()) {
                  fieldToOCR.valid = '0'
                  fieldToOCR.errorDesc = that.$i18n.t('errors.Data_inconsistent')
                }
                if (fieldToOCR.errorDesc) {
                  let parsedError = fieldToOCR.errorDesc.replace(/\s/g, '_')
                  if (that.$i18n.t('errors.' + parsedError) !== 'errors.' + parsedError) {
                    fieldToOCR.errorDesc = that.$i18n.t('errors.' + parsedError)
                  }
                }
              }
              if (key === 'DeliveryDate' || key === 'EmissionDate') {
                step.documentDate = ExtractedValue
              }
            }
          }
        }
        this.refreshImport = !this.refreshImport
      })
      .catch(err => {
        that.$f7.hidePreloader()
        that.$f7.closeModal()
        alert(that.$i18n.t('errors.too_important_tilt') + ' ' + err)
        console.log(that.$i18n.t('errors.too_important_tilt') + ' ' + err)
      })
    },
    hasError (field) {
      return field.valid === '0' &&
        !this.demoErrorSilent.includes(field.errorDesc)
    },
    openFileSelectionWindow (e, buttonRef) {
      e.stopPropagation()
      this.$refs[buttonRef][0].click()
    },
    refreshVue () {
      console.log('REFRESH VUE')
      this.refreshImport = !this.refreshImport
    },
    refuseStep () {
      let that = this
      let labelOption = [
        'doc_not_file',
        'doc_falsified',
        'doc_unreadable',
        'doc_bad_number',
        'doc_bad_name',
        'doc_bad_address',
        'doc_expired',
        'doc_good_but_sign'
      ]
      let options = ''
      for (let id in labelOption) {
        let label = that.$i18n.t('common.rfsl.Status.s_' + labelOption[id])
        let value = id
        options += '<option value="' + value + '">' + label + '</option>'
      }
      let modalText = '<div>' +
                    '<span>Sélectionner un motif de refus :</span>' +
                    '<select id="selectCodeRefus" style="width:200px;">' +
                      options +
                    '</select>' +
                  '</div>'

      this.$f7.modal({
        title: that.$i18n.t('businessDocuments.refuse_doc_confirmation'),
        text: modalText,
        buttons: [
          {
            text: that.$i18n.t('common.cncl'),
            onClick: function () {}
          },
          {
            text: that.$i18n.t('common.refus'),
            onClick: function () {
              that.decideStep(105)
            }
          }
        ]
      })
    },
    showActionButtons () {
      return this.currentStep.status === 101 ||
        this.currentStep.status === 102 ||
        this.currentStep.status === 105 ||
        this.currentStep.status === 106 ||
        (this.currentStep.status === 103 && this.$engine.user.get().identifier === 'backoffice@demosoft.com')
    },
    showActionButtonValidate () {
      return (this.currentStep.status === 101 ||
        this.currentStep.status === 102 ||
        this.currentStep.status === 105 ||
        this.currentStep.status === 106) &&
        this.$engine.user.get().identifier !== 'backoffice@demosoft.com'
    },
    showActionButtonValidateBackOffice () {
      return this.currentStep.status === 103 && this.$engine.user.get().identifier === 'backoffice@demosoft.com'
    },
    showWithDependency (field, fields) {
      if (field.dependency) {
        let dependenciesBool
        let dependenciesIdOR = []
        let dependenciesIdAND = []
        let dependenciesValueOR = []
        let dependenciesValueAND = []
        if (field.dependency.id.includes('|')) {
          dependenciesBool = false
          dependenciesIdOR = field.dependency.id.split('|')
          dependenciesValueOR = field.dependency.value.split('|')
        } else if (field.dependency.id.includes('&')) {
          dependenciesBool = true
          dependenciesIdAND = field.dependency.id.split('&')
          dependenciesValueAND = field.dependency.value.split('&')
        }
        for (let indexFieldToCheck in fields) {
          let fieldToCheck = fields[indexFieldToCheck]
          if (fieldToCheck.id === field.dependency.id) {
            if (field.dependency.operator) {
              switch (field.dependency.operator) {
                case '!':
                  return fieldToCheck.value !== field.dependency.value
                case '<':
                  return parseFloat(fieldToCheck.value) < parseFloat(field.dependency.value)
                case '>':
                  return parseFloat(fieldToCheck.value) > parseFloat(field.dependency.value)
                default:
                  if (field.dependency.value.includes('|')) {
                    return field.dependency.value.split('|').includes(fieldToCheck.value)
                  }
                  return fieldToCheck.value === field.dependency.value
              }
            }
            return fieldToCheck.value === field.dependency.value
          } else if (dependenciesIdOR.length && dependenciesIdOR.includes(fieldToCheck.id)) {
            let idDependencies = dependenciesIdOR.indexOf(fieldToCheck.id)
            dependenciesBool = dependenciesBool || fieldToCheck.value === dependenciesValueOR[idDependencies]
          } else if (dependenciesIdAND.length && dependenciesIdAND.includes(fieldToCheck.id)) {
            let idDependencies = dependenciesIdAND.indexOf(fieldToCheck.id)
            dependenciesBool = dependenciesBool && fieldToCheck.value === dependenciesValueAND[idDependencies]
          }
        }
        if (dependenciesIdOR.length || dependenciesIdAND.length) {
          return dependenciesBool
        }
      }
      return true
    }
  }
}
</script>
<style scoped>
</style>



// WEBPACK FOOTER //
// SupplierKYCFormStep.vue?64d6c1b4